// App Store Configuration
export const APP_CONFIG = {
  // App Store Links - Replace with your actual app store URLs
  appStore: {
    ios: "https://apps.apple.com/eg/app/golden-ticket-%D9%82%D9%88%D9%84%D8%AF%D9%86-%D8%AA%D9%8A%D9%83%D8%AA/id6751768421", // Replace with your iOS App Store URL
    android: "https://play.google.com/store/apps/details?id=your.app.package", // Replace with your Android Play Store URL
  },

  // App Information
  app: {
    name: "Golden Ticket",
    nameAr: "قولدن تيكت",
    description: "لتجربة أفضل حمل التطبيق",
    rating: 5, // Out of 5 stars
    icon: "/favicon.svg",
  },

  // Download Bar Settings
  downloadBar: {
    enabled: true,
    dismissKey: "app-download-bar-dismissed",
    showDelay: 0, // Delay in milliseconds before showing (0 = immediate)
  },
};

export default APP_CONFIG;
